class InfrasecRegisterService extends BaseService
	@register()
	@inject 'translate',
		'ConfigurationService'
		'InfrasecRepository'
		'ToastService'

	initialize: ->
		@settings =
			enabled: null
			auto_enroll: true
			has_ccuid: false
			status: null
			path: null
		@init()

		@InfrasecRepository
			.status()
			.then (response) =>
				@settings.enabled = response.data.active and
					response.data.enabled and
					@ConfigurationService.isEnabled 'Backoffice.Permission.InfraSecIntegration.Enabled'
			.catch =>
				@settings.enabled = false

	init: (register = null) ->
		@register = register
		@attributesService = null
		@settings.auto_enroll = true
		@settings.has_ccuid = false
		@settings.status = null
		@settings.path = null

	enroll: ->
		@InfrasecRepository
			.enrollRegister(@register.id)
			.then (response) =>
				@settings.has_ccuid = true
				@settings.status = true
				@attributesService.setAttribute 'infrasec_external_register_id', response.data.RegisterID
			.catch (response) =>
				@showError(response)

	open: ->
		@InfrasecRepository
			.openRegister(@register.id)
			.then =>
				@status()
			.catch (response) =>
				@showError(response)

	close: ->
		@InfrasecRepository
			.closeRegister(@register.id)
			.then =>
				@status()
			.catch (response) => @showError(response)

	status: ->
		if @settings.enabled && @settings.has_ccuid
			@InfrasecRepository
				.registerStatus(@register.id)
				.then (response) =>
					info = response.data.Info

					@settings.status = response.data.Active == '1'
					@settings.path = "#{info.PartnerAuthority.PartnerName} - #{info.OrganizationChain.ChainName} - #{info.StoreInfo.StoreName}"
				.catch (response) =>
					@showError(response)

	showError: (response) ->
		@ToastService.showErrors response, @translate('infrasec.central.control.unit.id')
